<template>
  <div class="g-wrapper">
    <div class="g-main">
      <img src="../assets/intrTitle.png" alt="" class="u-intrTitle" />
    </div>
    <div class="g-main">
      <div class="g-containt">
        <div v-for="(item, index) in forumList" :key="index">
          <div class="m-intr">
            <div class="u-Title">{{ item.name }}</div>
            <div class="u-theme"><span>主题</span> {{ item.theme }}</div>
            <div class="u-time">
              <img src="../assets/iconTime.png" alt="" class="u-iconTime" />
              <span class="u-date">{{item.date}}</span>
              <span class="u-clock">{{item.time}}</span>
              <span class="u-today">{{item.today}}</span>
            </div>
            <img
              :src="require('../assets/' + Number(index + 1) + '.png')"
              alt=""
              class="u-banner-img"
            />
            <div :class="item.isShow ? 'intrTextBox' : 'intrTextBox hide'">
              <p
                class="u-intrText"
                v-for="(intr, intrIndex) in item.intrText"
                :key="intrIndex"
              >
                {{ intr }}
              </p>
            </div>
            <div class="u-toggleBox" @click="item.isShow = !item.isShow"  v-if="index < forumList.length - 1">
              <img src="../assets/icon1.png" alt="" :class="item.isShow?'u-icon1':'u-icon1 up'" />
              
              <span v-if="item.isShow">收起</span>
              <span v-else>展开</span>
            </div>
          </div>
          <img
            src="../assets/hr.png"
            alt=""
            class="u-hr"
            v-if="index < forumList.length - 1"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      forumList: [
        {
          name: "2021第十届中国上市公司高峰论坛",
          theme: "科技创新 绿色发展",
          date: "2021/12/20",
          time: "09:30-17:00",
          today: "MON",
          isShow: true,
          intrText: [
            "当前，新一轮科技革命和产业变革正在深刻改变经济格局和人类生活，在新冠肺炎疫情仍在全球蔓延的背景下，更需要科技界、产业界深化合作，协力推动构建人类命运共同体，为全人类共同面对的重大问题探讨科技解决方案。",
            "9月24日，国家主席习近平向2021中关村论坛视频致贺时表示，当今世界，发展科学技术必须具有全球视野，把握时代脉搏，紧扣人类生产生活提出的新要求。中国高度重视科技创新，致力于推动全球科技创新协作，将以更加开放的态度加强国际科技交流，积极参与全球创新网络，共同推进基础研究，推动科技成果转化，培育经济发展新动能，加强知识产权保护，营造一流创新生态，塑造科技向善理念，完善全球科技治理，更好增进人类福祉。",
            "加强科技开放合作，全球需要共同应对时代挑战。科技创新，构建高水平开放体系，打造可持续内生动力，是新时期培育经济发展新动能的需要。",
            "对国内企业而言，如何在新时代的浪潮中，借助科技创新的力量带动企业高质量发展，是新的课题。同时，ESG（环境、社会和公司治理）也对国内企业提出了更高要求。",
            "2021第十届中国上市公司高峰论坛主论坛将以“科技创新 绿色发展”为主题，邀请众多国内顶尖经济学者、知名企业家、上市公司董事长（总裁）等，以新的视角，围绕科技创新、高水平开放、碳中和等话题献上一场顶级智慧碰撞。",
          ],
        },
        {
          name: "2021中国“专精特新”企业发展论坛",
          theme: "寻找隐形冠军 拥抱时代机遇",
          date: "2021/12/21",
          time: "09:30-12:00",
          today: "TUE",
          isShow: true,
          intrText: [
            "它们不是世界500强，也没有耀眼的知名度，它们常年专注于一个细分领域，默默扎根，长成“小巨人”，矗立于世界之巅。这是一群“隐形冠军”，我们叫它“专精特新”企业。",
            "它们往往都有着超强的难以模仿的自生能力，成功利用利基战略，选择一个狭窄而有深度的市场，毫不犹豫地坚持目标，并且总是以自己可以承受的代价来进行产品的更新换代。因此，它们能够实现长期的、可持续的成长，进而成为真正的长寿企业。",
            "现在，这群活跃在国民经济各个角落的“专精特新”企业，迎来了新的利好消息。",
            "2021年9月2日，习近平总书记在中国国际服务贸易交易会全球服务贸易峰会上发表致辞，指出”我们将继续支持中小企业创新发展，深化新三板改革，设立北京证券交易所，打造服务创新型中小企业主阵地。”",
            "11月15日，北交所正式开市。北交所以服务创新型中小企业为定位，支持先进制造业和现代服务业等领域的企业，推动传统产业转型升级，重点培育“专精特新”中小企业。",
            "对于我国而言，培育“专精特新”中小企业具有深远的意义。一方面，这一类企业竞争力强，是细分领域的的“王者”；另一方面，它们是解决我国技术“卡脖子”问题的重要力量，是连接“断点”、疏通“堵点”的重要支撑；第三，若更多“专精特新”企业被培育出来，将大大提升我国经济的整体竞争力。",
            "时代潮流奔涌向前，在北交所成立、中小企业成长的过程中，历史性机遇也随之而来。怎么打造“专精特新”企业？怎么成为“隐形冠军”？怎么借鉴别人的成功之道？怎么筛选出“牛气冲天”的好公司？",
            "在此背景之下，每日经济新闻将于12月21日在线上举办“2021中国‘专精特新’企业发展论坛”。论坛以“寻找隐形冠军 拥抱时代机遇”为主题，探讨“专精特新”企业的成长路径、北交所成立带来的历史机遇、北交所上市规则解读、潜力股的挖掘等诸多话题。",
          ],
        },
        {
          name: "2021中国企业低碳发展论坛",
          theme: "碳中和新局  现实与路径",
          date: "2021/12/21",
          time: "14:00-17:00",
          isShow: true,
          today: "TUE",
          intrText: [
            "中国宣布二氧化碳排放力争于2030年前达到峰值，努力争取2060年前实现碳中和。“双碳”目标的提出为中国减排脱碳按下了“加速键”，也对企业适应低碳时代的新发展模式提出了更高要求。",
            "有专家预测，中国实现“双碳”目标需投资约在150万亿到300万亿元。碳中和是未来经济发展的大战略，机遇和挑战并行。在碳中和的目标之下，各行业都在摩拳擦掌、争抢先机，其中，尤其是环保、能源两个行业的最受关注，资本、技术等都在向这些行业快速倾斜，低碳发展、绿色转型的重任在肩，也是行业发展的新赛道。我们以环保、能源行业为重点，邀请政府智囊、行业专家、投行领导、上市公司企业家等各方齐聚一堂，共谋低碳发展的新商机。",
          ],
        },
        {
          name: "2021中国品质消费创新发展论坛",
          theme: "新韧劲 新活力",
          date: "2021/12/22",
          time: "09:30-11:50",
          isShow: true,
          today: "WED",
          intrText: [
            "第十届中国上市公司高峰论坛年会周将于2021年12月20日至12月24日线上举办。",
            "中国上市公司高峰论坛由每日经济新闻于2011年发起主办，迄今已成功举办九届，是中国最具影响力的高端财经论坛之一。历届论坛均聚集国内外知名上市公司、知名券商、基金公司管理者、海内外优秀经济学家，探讨年度资本和产业热点话题，是中国资本市场的年度重要盛会",
            "2021年，是“十四五”开局之年，也是全面建设社会主义现代化国家新征程的起步之年，在我国现代化建设进程中具有特殊重要性。",
            "置身中华民族伟大复兴战略全局和世界百年未有之大变局，当前，消费和投资增速虽有回落，但不乏亮点。我国扩内需依然后劲十足：14亿人口市场潜力巨大，提振大宗消费、重点消费政策扎实有力……超大规模市场潜力无限，品质消费市场韧性强、活力足。",
            "奋进新征程，中国消费领域的新韧性、新活力还有哪些？消费品上市公司、新兴独角兽企业将呈现哪些新特点，又该如何创新发展？",
            "2021中国品质消费创新发展论坛将以“新韧劲、新活力”为主题，邀请众多国内顶尖经济学者、知名企业家、上市公司董事长（总裁）等，以新的视角，围绕品质消费、数智消费、绿色消费等话题献上一场顶级智慧碰撞。",
          ],
        },
        {
          name: "2021中国医药健康资本论坛",
          theme: "启智未来：后疫情时代蝶变",
          date: "2021/12/22",
          time: "14:00-17:10",
          isShow: true,
          today: "WED",
          intrText: [
            "第十届中国上市公司高峰论坛年会周将于2021年12月20日至12月24日线上举办。",
            "中国上市公司高峰论坛由每日经济新闻于2011年发起主办，迄今已成功举办九届，是中国最具影响力的高端财经论坛之一。历届论坛均聚集国内外知名上市公司、知名券商、基金公司管理者、海内外优秀经济学家，探讨年度资本和产业热点话题，是中国资本市场的年度重要盛会",
            "在产业深度升级和经济高质量背景下，千行万业迈入智能化发展的全新时代，进入一个上限更高、空间更大的智能化全新领域。特别是在2020年以后，新冠肺炎疫情席卷全球，技术赋能下产业融合进一步加速，新经济百花齐放，健康中国迈入新征程。",
            "面对智能时代的历史新机遇，医药健康产业正迎来崭新的融合与重构。一方面，是传统医药健康与信息化、数字化之间的链接，另一方面，是从个体到组织的智能化普及与发展，催生出更多新的健康需求。但在巨大的创新发展空间下，前行道路并不平坦，产业如何通过资本助力快速顺应新时代需求加速成长，成为每个企业不得不探索的问题。",
            "由每日经济新闻主办的2021中国上市公司年会周之行业论坛：中国医药健康资本论坛以“共成长、同发展”为宗旨，持续推动医药健康产业与资本的跨界合作，以“合作、创新、科技、研发、资本”为宗旨，携手与会各方共同推动我国医药健康产业创新可持续发展，引领产业融合与发展。",
            "今年，大会将围绕“启智未来：后疫情时代蝶变”这一主题，从“健康中国”的生态建设出发，预判和分析产业趋势，多维度、立体化探讨多分支领域融合的路径。",
          ],
        },
        {
          name: "2021 人工智能未来应用场景论坛",
          theme: "AI是最强大脑吗？",
          date: "2021/12/23",
          time: "14:00-17:10",
          isShow: true,
          today: "THU",
          intrText: [
            "许多科幻片里无数次地呈现：将来的世界是人与机器人共生的世界。",
            "过去，我们学计算机是要懂得它的语言，现在我们要让计算机懂得人类的语言。",
            "有人说，人工智能是通向未来世界的一把钥匙；",
            "也有人说，人工智能的热潮只不过是一次资本驱动下的虚假趋势；",
            "从资本的疯狂追捧，到科技巨头、产业巨头乃至创业公司纷纷入局这一赛道，再到A 股市场人工智能概念股持续暴涨，游戏、社交、短视频......人工智能概念产物层出不穷",
            "当下，移动互联网红利已经到顶并开始消退；人工智能作为科学技术和现实世界融合的载体，蕴含着支付、驾驶、医疗、生活、社交、游戏、办公等场景变革的巨大机遇，传统科技企业和新型初创企业都在抢占未来新赛道。",
            "人工智能的作用和价值取决于未来若干年里，我们自身处于人工智能的什么位置，扮演什么角色，做出什么贡献以及获得多大的回报。本场主题为“AI 是最强大脑吗？” 的人工智能未来场景应用场景论坛，将探讨人工智能的未来应用场景，传递未来人工智能生态构建法则。",
          ],
        },
        {
          name: "2021中国投资价值趋势论坛",
          theme: "成长2022",
          date: "2021/12/23",
          time: "14:00-17:10",
          isShow: true,
          today: "THU",
          intrText: [
            "2021年，国内公私募基金规模放量增长，资本市场格局持续优化！这一年，北交所成立，全面注册制即将到来！这一年，行业赛道、价值成长、蓝筹小盘刻上分化“烙印”，新的价值逻辑正在重塑！",
            " 尤其是北交所的成立，意味在在专精特新的战略下，无论是市场本身还是相关上市公司都将迎来一个重要的发展契机。",
            "岁末之钟即将敲响，2022年该如何抒写新篇章、把握投资脉络？“中国投资价值趋势论坛——成长2022”诚邀行业大佬、市场大咖齐聚一堂，凝共识与合力，话成长与突破！",
          ],
        },
        {
          name: "2021第五届中国上市公司董秘峰会",
          theme: "ESG：全新机遇 共同责任",
          date: "2021/12/24",
          time: "09:30-12:00",
          isShow: true,
          today: "FRI",
          intrText: [
            "坐而论道，不如起而行之！",
            " 在中国经济向高质量增长转型、践行新发展理念、迈向碳中和目标、促进共同富裕的时代背景下，作为全面衡量上市公司可持续发展的评价体系，ESG（环境、社会与公司治理）越来越受到各界关注和重视，并日益成为重构上市公司品牌价值成长的新逻辑、新风口、新路径。",
            "基于这一时代背景，ESG对上市公司意味着全新机遇，也意味着共同责任。",
            "更加注重环境友好、生态和谐，特别是碳中和目标，对上市公司提出了新的要求，也指明了新的发展方向；更加注重社会责任、社会和谐，特别是共同富裕任务，激励上市公司持续创新、创造财富，同时更好地参与协调配套的三次分配；更加注重公司治理、规范发展，既优化内部小环境，提升公司治理水平和品牌形象，也改善外部大环境，提升中国资本市场的治理水平和品牌形象。",
            "ESG的每个方面，都带给上市公司充分的发展机遇，也是上市公司必须践行的共同责任。在很大程度上，ESG的水平高低，决定着公司的增长质量和发展前景。抓住ESG的全新机遇，践行ESG的共同责任，是每个上市公司正在面临、需要做答的时代命题。",
            "基于ESG的时代背景，面对ESG的全新机遇和共同责任，每日经济新闻作为一家主流财经智媒体，特以上述主题举办2021年第五届中国上市公司董秘峰会。",
            "围绕主题，峰会邀请知名学者、咨询专家、企业翘楚和上司公司董秘一起探讨以下话题，包括：ESG带给上市公司哪些新机遇？上市公司如何抓住ESG新机遇？上市公司需要履行哪些ESG责任？上市公司如何履行ESG责任？当下的中国上市公司在ESG方面还有哪些问题和不足？如何提升上市公司的ESG水平，助力上市公司更好发展等等。",
            "与此同时，借助2021年第五届中国上市公司董秘峰会，每日经济新闻希望搭建起一个汇聚各方资源的平台，致力于中国上市公司ESG研究，结合高校专家资源和财经媒体传播优势，推进产学研深度融合，更好地为上市公司提供ESG的产品和服务。",
          ],
        },
        {
          name: "2021中国上市公司品牌价值蓝皮书发布",
          theme: "暨2021中国资本市场荣誉盛典",
          date: "2021/12/24",
          time: "14:30-17:00",
          isShow: true,
          today: "FRI",
          intrText: ['如今，年方而立的资本市场已经成为居民资产配置、财富保值增值的重要场所。每日经济新闻从2010年启动上市公司口碑榜的评选已历时十年，我们希望这一届的评选，在资本市场监管日趋完善的大背景下，能挖掘出更多值得尊敬，值得期待，更值得投资的好公司！同时，伴随《2021中国上市公司品牌价值蓝皮书》发布，我们希望以科学多维的方式量化品牌价值影响，给与企业提升综合影响力的实例参考和优化建议。'],
        },
      ],
    };
  },
};
</script>

<style lang='scss' scoped>
.u-intrTitle {
  width: 501px;
  height: 118px;
  display: block;
  margin: 30px auto;
}
.m-intr {
  overflow: hidden;
  padding: 35px 60px;
  .u-Title {
    font-size: 36px;
    color: #272727;
    padding-bottom: 10px;
    border-bottom: 1px solid #dbdbde;
    text-align: center;
  }
  .u-theme {
    color: #535353;
    font-size: 30px;
    text-align: center;
    margin-top: 20px;
    span {
      display: inline-block;
      padding: 5px 10px;
      background: #ededed;
      font-weight: bolder;
      border-radius: 8px;
    }
  }
  .u-banner-img {
    margin: 30px auto;
  }
}
.u-iconTime {
  width: 29px;
  height: 29px;
  margin-right: 15px;
}
.u-time {
  display: flex;
  align-items: center;
  color: #4383b8;
  margin-top: 25px;
  .u-date {
    font-size: 36px;
    margin-right: 15px;
  }
  .u-clock {
    font-size: 30px;
    margin-right: 15px;
  }
  .u-today {
    font-size: 12px;
    align-items: baseline;
  }
}
.u-intrText {
  text-indent: 2em;
  font-size: 30px;
  color: #535353;
  line-height: 1.5;
  margin-bottom: 10px;
}
.u-toggleBox {
  width: 162px;
  height: 45px;
  box-sizing: border-box;
  border: 1px solid #75a4cb;
  color: #75a4cb;
  font-size: 30px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  margin: 0 auto;
  margin-top: 15px;
}

.u-icon1 {
  width: 29px;
  height: 29px;
  transition: all 0.5s;
  &.up {
    transform: rotate(180deg);
  }
}
.hide {
  display: none;
}
</style>